module.exports = __webpack_public_path__ + "img/百香果11.088f8203.png";